import Sentry from './common/utils/middleware/config.sentry.js'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { ClarityProvider } from '@artprov/design-system'

if (import.meta.env.DEV) {
  const getMessage = (arg) => {
    if (typeof arg === 'string') return arg
    if (arg instanceof Error && arg.message) return arg.message
    if (arg && typeof arg.message === 'string') return arg.message
    return ''
  }

  const shouldSuppress = (args) => {
    if (!Array.isArray(args) || args.length === 0) return false
    const combined = args.map(getMessage).join(' ')

    const isPropTypeWarning = combined.includes('Warning: Failed prop type')
    const isClassNameIcon = combined.includes('classNameIcon')
    const isClassName = combined.includes('Invalid prop `className`')
    const isTargetComponent =
      combined.includes('`be`') || combined.includes('`Xt`') || combined.includes('expected one of type')

    return isPropTypeWarning && (isClassNameIcon || isClassName) && isTargetComponent
  }

  const originalError = console.error
  const originalWarn = console.warn

  console.error = (...args) => {
    if (shouldSuppress(args)) return
    originalError(...args)
  }

  console.warn = (...args) => {
    if (shouldSuppress(args)) return
    originalWarn(...args)
  }
}

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('No se encontró el elemento root')
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ClarityProvider projectId={import.meta.env.VITE_CLARITY_ID} sentry={Sentry}>
      <App />
    </ClarityProvider>
  </React.StrictMode>
)
